






































































































import { ICompany } from '@/interfaces';
import { http } from '@/services';
import AddCompanyDialog from '@/views/companies/add-company.component.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: { AddCompanyDialog },
})
export default class CompaniesHome extends Vue {
  protected companies: Array<ICompany> = [];
  protected showDialog: boolean = false;
  protected breadcrumbItems: Array<any> = [
    { text: 'Empresas', disabled: true },
  ];

  protected async mounted(): Promise<void> {
    this.companies.push(...(await http.get('/companies')).data);
  }

  protected async changeStatus(companyId: number, companyStatus: string): Promise<void> {
    if (companyStatus === 'Ativo') {
      await http.delete(`/companies/${companyId}`);
    } else {
      await http.post(`/companies/${companyId}/reactivate`);
    }
    await this.reload();
  }

  protected async reload(): Promise<void> {
    this.companies.splice(0);
    this.companies.push(...(await http.get('/companies')).data);
    this.showDialog = true;
  }
}
